<template>
  <v-row justify="center">
    <v-dialog v-model="showModal" persistent max-width="800px">
      <v-card :loading="loading" :disabled="cardDisabled">
        <v-card-title>
          <span class="headline">{{ $t('Update Password') }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-alert
              text
              prominent
              dismissible
              v-model="alertShow"
              type="error"
              icon="mdi-alert"
            >{{ alertText }}</v-alert>
            <v-form ref="form" v-model="isFormValid">
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    :label="newPasswordLabel"
                    v-model="newPassword"
                    :rules="newPasswordRules"
                    :append-icon="showNewPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="showNewPassword ? 'text' : 'password'"
                    name="password"
                    @click:append="showNewPassword = !showNewPassword"
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    :label="repeatedPasswordLabel"
                    v-model="repeatedPassword"
                    :rules="repeatedPasswordRules"
                    :error-messages="errorMessages"
                    :append-icon="showRepeatedPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="showRepeatedPassword ? 'text' : 'password'"
                    name="password"
                    @click:append="showRepeatedPassword = !showRepeatedPassword"
                    dense
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="darken-1" text @click="hide">{{ $t('close') }}</v-btn>
          <v-btn
            color="darken-1"
            :disabled="!isFormValid"
            text
            @click="updatePassword"
          >{{ $t('update') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import axios from "axios";
import i18n from "../../i18n";
import EventBus from "../../event-bus";

export default {
  name: "UpdatePasswordModal",
  watch: {
    newPassword: function (val) {
      if (
        val != "" &&
        this.repeatedPassword != "" &&
        val != this.repeatedPassword
      ) {
        this.errorMessages = [i18n.t("Passwords does not match!")];
      } else {
        this.errorMessages = [];
      }
    },
    repeatedPassword: function (val) {
      if (val != "" && val != this.newPassword) {
        this.errorMessages = [i18n.t("Passwords does not match!")];
      } else {
        this.errorMessages = [];
      }
    },
  },
  data: () => ({
    isFormValid: true,
    showModal: false,
    loading: false,
    cardDisabled: false,
    alertText: null,
    alertShow: false,
    showNewPassword: false,
    errorMessages: [],
    newPassword: "",
    newPasswordLabel: i18n.t("New Password"),
    newPasswordRules: [],
    showRepeatedPassword: false,
    repeatedPassword: "",
    repeatedPasswordLabel: i18n.t("Repeat password"),
    repeatedPasswordRules: [],
  }),
  created() {
    this.newPasswordRules = [
      (v) => !!v || i18n.t("Password is required"),
      (v) => v.length <= 50 || i18n.t("Max 50 characters"),
      (v) => v.length >= 5 || i18n.t("Min 5 characters"),
      (v) => (v || "").indexOf(" ") < 0 || i18n.t("No spaces are allowed"),
    ];
    this.repeatedPasswordRules = [
      (v) => !!v || i18n.t("Password is required"),
      (v) => v.length <= 50 || i18n.t("Max 50 characters"),
      (v) => v.length >= 5 || i18n.t("Min 5 characters"),
      (v) => (v || "").indexOf(" ") < 0 || i18n.t("No spaces are allowed"),
    ];
  },
  methods: {
    cleanErrorsAndTexts() {
      this.alertText = "";
      this.alertShow = false;
      this.newPassword = "";
      this.repeatedPassword = "";
    },
    sendErrorAndCloseModal(error) {
      if (error.response) {
        if (
          error.response.status == 400 &&
          error.response.data.status == "error"
        ) {
          EventBus.$emit("SHOW_ERROR", error.response.data.error);
        } else {
          EventBus.$emit("SHOW_ERROR", error.response.data);
        }
      } else {
        EventBus.$emit("SHOW_ERROR", error);
      }

      this.loading = false;
      this.showModal = false;
    },
    sendErrorOnModal(error) {
      if (error.response) {
        if (
          error.response.status == 400 &&
          error.response.data.status == "error"
        ) {
          this.alertText = error.response.data.error;
        } else {
          this.alertText = error.response.data;
        }
      } else {
        this.alertText = error;
      }

      this.loading = false;
      this.alertShow = true;
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    show() {
      this.alertShow = false;
      this.alertText = "";
      this.showModal = true;
    },
    updatePassword() {
      let data = {};
      data.password = this.newPassword;

      axios({
        url: "/api/account/user",
        headers: { "Content-Type": "application/json" },
        data: data,
        method: "PUT",
      })
        .then((response) => {
          this.saveLoading = false;

          if (
            !response.data ||
            !response.data.status ||
            !(response.data.status == "success")
          ) {
            EventBus.$emit("SHOW_ERROR", response);
          } else {
            this.loading = false;
            this.showModal = false;
            this.cleanErrorsAndTexts();
            this.resetValidation();
          }
        })
        .catch((error) => {
          this.saveLoading = false;
          this.sendError(error);
        });
    },
    hide() {
      this.loading = false;
      this.showModal = false;
      this.cleanErrorsAndTexts();
      this.resetValidation();
    },
  },
};
</script>

<style scoped>
.v-alert {
  overflow: hidden;
}
</style>